(() => {
  'use strict';
  document.querySelectorAll('[data-vr-product]').forEach(root => {
    const data = root.querySelector('[data-vr-variants]');
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    const form = root.querySelector('.vr-product-form');
    const main = root.querySelector('.vr-main-image img');
    const photos = [...root.querySelectorAll('[data-vr-photo]')];
    const track = root.querySelector('[data-vr-gallery-track]');
    const slides = [...root.querySelectorAll('[data-vr-slide]')];
    const previous = root.querySelector('[data-vr-gallery-previous]');
    const next = root.querySelector('[data-vr-gallery-next]');
    const counter = root.querySelector('[data-vr-gallery-count]');
    const path = value => { try { return new URL(value, location.href).pathname; } catch { return value; } };
    let activeIndex = 0;
    let requestedIndex = null;
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const updatePhoto = index => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      photos.forEach((button, position) => button.setAttribute('aria-pressed', String(position === activeIndex)));
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
      if (counter) counter.textContent = (activeIndex + 1) + ' / ' + slides.length;
      const selectedPhoto = photos[activeIndex];
      const thumbnails = selectedPhoto?.parentElement;
      if (thumbnails && (selectedPhoto.offsetLeft < thumbnails.scrollLeft || selectedPhoto.offsetLeft + selectedPhoto.offsetWidth > thumbnails.scrollLeft + thumbnails.clientWidth)) {
        thumbnails.scrollTo({ left: selectedPhoto.offsetLeft - (thumbnails.clientWidth - selectedPhoto.offsetWidth) / 2, behavior: motion() });
      }
    };
    const showPhoto = index => {
      if (!track || !slides.length) return;
      updatePhoto(index);
      requestedIndex = activeIndex;
      track.scrollTo({ left: activeIndex * track.clientWidth, behavior: motion() });
    };
    const activatePhoto = (url, alt) => {
      const index = photos.findIndex(button => path(button.dataset.vrPhoto) === path(url));
      if (index >= 0) showPhoto(index);
    };
    photos.forEach((button, index) => button.addEventListener('click', () => showPhoto(index)));
    previous?.addEventListener('click', () => showPhoto(activeIndex - 1));
    next?.addEventListener('click', () => showPhoto(activeIndex + 1));
    if (track && slides.length) {
      let scrollFrame = 0;
      track.scrollLeft = 0;
      updatePhoto(0);
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          if (requestedIndex !== null && Math.abs(track.scrollLeft - requestedIndex * track.clientWidth) > 2) { scrollFrame = 0; return; }
          requestedIndex = null;
          updatePhoto(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
          scrollFrame = 0;
        });
      }, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        const index = event.key === 'ArrowRight' ? activeIndex + 1 : event.key === 'ArrowLeft' ? activeIndex - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : null;
        if (index !== null) { event.preventDefault(); showPhoto(index); }
      });
      let drag = null;
      track.addEventListener('pointerdown', event => {
        requestedIndex = null;
        if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2) return;
        event.preventDefault();
        drag = { x: event.clientX, left: track.scrollLeft, pointer: event.pointerId };
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', event => {
        if (drag) track.scrollLeft = drag.left + drag.x - event.clientX;
      });
      const endDrag = () => {
        if (!drag) return;
        const pointer = drag.pointer;
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(pointer)) track.releasePointerCapture(pointer);
        showPhoto(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);
      track.addEventListener('wheel', () => { requestedIndex = null; }, { passive: true });
      new ResizeObserver(() => { track.scrollLeft = activeIndex * track.clientWidth; }).observe(track);
    }
    const currency = root.dataset.currency || 'USD';
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(value / 100);
    form.addEventListener('change', event => {
      if (!event.target.matches('input[name="id"]')) return;
      const variant = variants.find(v => String(v.id) === event.target.value);
      if (!variant) return;
      root.querySelector('[data-vr-price]').textContent = money(variant.price);
      const compare = root.querySelector('[data-vr-compare]');
      compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = compare.hidden ? '' : money(variant.compare_at_price);
      root.querySelector('[data-vr-stock]').textContent = variant.available ? 'Available to order' : 'Currently unavailable';
      root.querySelector('[data-vr-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out';
      root.querySelector('.vr-add-button').disabled = !variant.available || form.dataset.submitting === 'true';
      const quantity = form.querySelector('input[name="quantity"]');
      const rules = variant.quantity_rule || { min: 1, increment: 1 };
      quantity.min = rules.min || 1; quantity.step = rules.increment || 1;
      if (rules.max) quantity.max = rules.max; else quantity.removeAttribute('max');
      quantity.value = rules.min || 1;
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
      if (variant.featured_image?.src) activatePhoto(variant.featured_image.src, main?.alt || 'Voltreya product');
    });
    root.querySelectorAll('[data-vr-buy-quantity]').forEach(button => button.addEventListener('click', () => {
      const input = form.querySelector('input[name="quantity"]');
      const value = Math.max(Number(input.min) || 1, Number(input.value) + Number(button.dataset.vrBuyQuantity) * (Number(input.step) || 1));
      if (!input.max || value <= Number(input.max)) input.value = value;
    }));
  });
  document.querySelectorAll('[data-vr-product-details]').forEach(details => {
    details.querySelectorAll('iframe').forEach(frame => {
      if (!frame.title) frame.title = 'Product video';
      if (!frame.loading) frame.loading = 'lazy';
    });
    details.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('vr-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'vr-table-scroll';
      table.before(wrapper);
      wrapper.append(table);
    });
  });
})();
